import {timeMaps} from '../util'
import dayjs from 'dayjs'
const prefixCls = 'ivu-picker-panel';
const datePrefixCls = 'ivu-date-picker';

export default {
  props: {
    confirm: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    iconBtnCls(direction, type = '') {
      return [
        `${prefixCls}-icon-btn`,
        `${datePrefixCls}-${direction}-btn`,
        `${datePrefixCls}-${direction}-btn-arrow${type}`,
      ];
    },
    handleShortcutClick(shortcut) {
      this.clickToggle = true
      this.presetText = shortcut.text;
        this.$emit('on-pick', shortcut.value())
        Promise.resolve()
          .then(() => {
            this.dynamicRangeText = shortcut.text;
          })
      if (shortcut.onClick) shortcut.onClick(this);
    },
    handlePickClear() {
      this.resetView();
      this.$emit('on-pick-clear');
    },
    handlePickSuccess() {
      this.resetView();
      const dText = this.dynamicRangeText;


      const [day1, day2] = this.publicStringValue.map(item => dayjs(item))
      let comparedDates
      if (this.dates[1]) {
        const [comDay1, comDay2] = this.dates
        const d1 = dayjs(comDay1).hour(day1.hour()).minute(day1.minute()).second(day1.second()).format('YYYY-MM-DD HH:mm:ss')
        const d2 = dayjs(comDay2).hour(day2.hour()).minute(day2.minute()).second(day2.second()).format('YYYY-MM-DD HH:mm:ss')
        comparedDates = [d1, d2]
      }


      const dateResult = {
        isCompared: this.isCompared,
        isDynamic: this.isDynamic,
        baseDynamicDates: {
          unit: '',
          range: undefined
        },
        comparedDynamicDates: {
          term: 'base',
          unit: '',
          range: undefined
        },
        baseDates: this.publicStringValue,
        comparedDates
      };
      console.log(timeMaps, dText, timeMaps.some(item => item.value === dText), '/asdddddddd', dateResult, this.dynamicRangeType)

      if (dText === '') {
        this.$emit('on-pick-clear');
        return
      }
      // 动态时间范围
      if (timeMaps.some(item => item.value === dText)) {
        dateResult.baseDynamicDates = {
          unit: timeMaps.find(item => item.value === dText).key,
          range: undefined
        };
      } else {
        if (/最近/.test(dText)) {
          dateResult.baseDynamicDates = {
            unit: 'm2nDaysAgo',
            range: [Number(dText.replace(/[^0-9]/ig, "") - 1), 0]
          };
        } else {
          let range = dText.match(/\d+/g).map(item => Number(item))
          dateResult.baseDynamicDates = {
            unit: range.length === 1 ? 'lastNDays' : 'm2nDaysAgo',
            range: range
          };
        }
      }
      // 对比的动态时间范围

      if (!dateResult.comparedDates) {
        if (this.timeDisabled) {
          this.$Message.warning('请选择对比日期');
        } else {
          this.$emit('on-pick-success', dateResult);
        }
        return false;
      }

      const [startStr, endStr] = dateResult.comparedDates;
      const today = new Date(new Date().Format('end'));
      const startDate = new Date(startStr);
      const endDate = new Date(endStr);
      const start = Math.floor((today.getTime() - startDate.getTime()) / 86400000);
      const end = Math.floor((today.getTime() - endDate.getTime()) / 86400000);
      dateResult.comparedDynamicDates = {
        unit: 'm2nDaysAgo',
        range: [start, end]
      }

     /*  if (this.dynamicRangeType !== '') {

        const [startStr, endStr] = dateResult.comparedDates;
        const today = new Date(new Date().Format('end'));
        const startDate = new Date(startStr);
        const endDate = new Date(endStr);
        const start = Math.floor((today.getTime() - startDate.getTime()) / 86400000);
        const end = Math.floor((today.getTime() - endDate.getTime()) / 86400000);
        dateResult.comparedDynamicDates = {
          unit: 'm2nDaysAgo',
          range: [start, end]
        }
      } else {

        //dateResult.comparedDynamicDates = Object.assign({}, dateResult.//baseDynamicDates, {
        //  term: 'base'
        //})
        const [startStr, endStr] = dateResult.comparedDates;
        const today = new Date(new Date().Format('end'));
        const startDate = new Date(startStr);
        const endDate = new Date(endStr);
        const start = Math.floor((today.getTime() - startDate.getTime()) / 86400000);
        const end = Math.floor((today.getTime() - endDate.getTime()) / 86400000);
        dateResult.comparedDynamicDates = {
          unit: 'm2nDaysAgo',
          range: [start, end]
        }
      } */

      this.$emit('on-pick-success', dateResult);
    },
    handlePickClick() {
      this.clickToggle = false
      if (!this.isCompared) this.dynamicRangeText = '';
      this.dynamicRangeType = '';
      this.$emit('on-pick-click');
    },
    resetView() {
      setTimeout(
        () => this.currentView = this.selectionMode,
        500 // 500ms so the dropdown can close before changing
      );
    },
    handleClear() {
      this.dates = this.dates.map(() => null);
      this.rangeState = {};
      this.$emit('on-pick', this.dates);
      this.handleConfirm();
      //  if (this.showTime) this.$refs.timePicker.handleClear();
    },
    handleConfirm(visible, type) {
      this.$emit('on-pick', this.dates, visible, type || this.type);
    },
    onToggleVisibility(open) {
      const {timeSpinner, timeSpinnerEnd} = this.$refs;
      if (open && timeSpinner) timeSpinner.updateScroll();
      if (open && timeSpinnerEnd) timeSpinnerEnd.updateScroll();
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/my-components/custom-date-picker/panel/panel-mixin.js